import React, { useMemo } from 'react';
import { SnackbarProvider as NotistackProvider } from 'notistack';
import { isMobile } from 'helpers';
import { useTheme } from '@emotion/react';
import { css } from '@emotion/css';

const useWebClasses = () => {
  const theme = useTheme();

  return useMemo(() => ({
    containerRoot: css`
      && {
        z-index: ${theme.zIndex.tooltip};
      }
    `,
  }), [theme]);
};

const useMobileClasses = () => {

  const theme = useTheme();

  return useMemo(() => ({
    containerAnchorOriginBottomCenter: css`
      && {
        z-index: ${theme.zIndex.tooltip};
      }
      .has-mobile-tabbar && {
        bottom: 70px;
        @supports ((bottom: calc(env(safe-area-inset-bottom) + 70px))) {
          bottom: calc(env(safe-area-inset-bottom) + 70px);
        }
        @media (max-width: 400px) {
          max-width: 90vw;
          margin: 0 auto;
        }
      }
    `,
    root: css`
      && > * {
        opacity: 0.99;
        padding: 0 1rem;
        box-shadow: none;
      }
    `,
  }), [theme]);
};

const useClasses = isMobile ? useMobileClasses : useWebClasses;
const anchorOrigin = isMobile ? { vertical: 'bottom', horizontal: 'center' } : undefined;

const SnackbarProvider = (args) => {

  const classes = useClasses();

  return (
    <NotistackProvider
      classes={classes}
      autoHideDuration={4000}
      hideIconVariant={isMobile}
      dense={isMobile}
      anchorOrigin={anchorOrigin}
      {...args}
    />
  );
};

export default SnackbarProvider;
